// extracted by mini-css-extract-plugin
export var shake = "_17-0";